import React from 'react';

import CSS from './styles.scss';


const Spinner = () => {
  return (
    <div className={ CSS['spinner'] }>
      <div className={ CSS['rect1'] }></div>
      <div className={ CSS['rect2'] }></div>
      <div className={ CSS['rect3'] }></div>
      <div className={ CSS['rect4'] }></div>
      <div className={ CSS['rect5'] }></div>
    </div>
  );
};


export default Spinner;
